import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  contentWrapper: {
    display: 'flex',
    margin: theme.spacing(1, 0, 0.5),
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '175px',
    height: '30px',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: '4px 0px 0px 4px',
    borderRight: 'none',
  },
  label: {
    padding: theme.spacing(0, 1.25),
  },
  dayTimeTableContainer: {
    display: 'flex',
    borderRadius: '0px 4px 4px 4px',
    flex: 1,
    margin: 0,
  },
  dayTimeTable: {
    margin: 0,
  },
  footerWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
  },
  infoIcon: {
    marginRight: theme.spacing(1),
    width: '12px',
    height: '12px',
  },
}));

export default useStyles;
